import React, { useCallback, useEffect, useState } from 'react';
import { dmClient } from '../../services/dmClient';
import './admin.css';

export default function ClientsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', externalId: '' });
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const resp = await dmClient.get('/clients');
      setItems(resp.data?.data?.items || []);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Failed to load facilities');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await dmClient.post('/clients', form);
      setForm({ name: '', externalId: '' });
      load();
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Failed to create facility');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-head">
        <div>
          <h1>Facilities</h1>
          <p>
            Each facility is a billing client. Its id is the tenant key stamped on
            every denial, EHR record, and execution.
          </p>
        </div>
      </div>

      {error && <div className="admin-alert admin-alert--error">{error}</div>}

      <form className="admin-card admin-invite" onSubmit={create}>
        <h3>Add a facility</h3>
        <div className="admin-invite__row">
          <input type="text" placeholder="Facility name" required
                 value={form.name}
                 onChange={(e) => setForm((v) => ({ ...v, name: e.target.value }))} />
          <input type="text" placeholder="External id (optional)"
                 value={form.externalId}
                 onChange={(e) => setForm((v) => ({ ...v, externalId: e.target.value }))} />
          <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
            {saving ? 'Saving…' : 'Add facility'}
          </button>
        </div>
      </form>

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr><th>Name</th><th>External id</th><th>Client id</th><th>Status</th><th>Created</th></tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="admin-empty">Loading…</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={5} className="admin-empty">No facilities yet.</td></tr>
            )}
            {!loading && items.map((c) => (
              <tr key={c.ClientId}>
                <td>{c.Name}</td>
                <td>{c.ExternalId || '—'}</td>
                <td><code className="admin-mono">{c.ClientId}</code></td>
                <td>
                  <span className={`admin-status admin-status--${(c.Status || '').toLowerCase()}`}>
                    {c.Status}
                  </span>
                </td>
                <td>{c.CreatedAt ? new Date(c.CreatedAt).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
